import defaultTheme from './defaultTheme';
const bpTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#007833', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#007833', background: '#007833' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#007833' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#007833', border: '#007833', background: '#007833' }), field: {
        focus: '#007833',
        label: '#007833',
        icon: '#007833',
    } });
export default bpTheme;
